import store from '../store';

const lib = {
	translate: (key, alt = true) => {
		return store.getters.TRANSLATES[key] ? store.getters.TRANSLATES[key] : (alt ? key : '');
	},
	dateParser: (date) => {
		if (date) {
			const parse = new Date(date);

			let dd = parse.getDate();
			let mm = parse.getMonth() + 1;
			let yyyy = parse.getFullYear();

			if (dd < 10) {
				dd = '0' + dd;
			}

			if (mm < 10) {
				mm = '0' + mm;
			}

			return dd + '.' + mm + '.' + yyyy;
		} else {
			return false;
		}
	},
	scrollTo: (to, callback) => {
		const duration = 500;
		const increment = 15;
		const start = document.documentElement.scrollTop;
		const change = to - start;
		let currentTime = 0;

		const easeInOutQuad = (t, b, c, d) => {
			t /= d/2;
			if (t < 1) return c/2*t*t + b;
			t--;
			return -c/2 * (t*(t-2) - 1) + b;
		};

		let scrollInterval = setInterval(() => {
			if (currentTime < duration) {
				currentTime += increment;
				document.documentElement.scrollTop = easeInOutQuad(currentTime, start, change, duration);
			} else {
				clearInterval(scrollInterval);
				if (callback) {
					callback();
				}
			}
		}, increment);
	}
};

export default lib;
